(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-anuncio"] && !Shopify.designMode) return;
  try {
    
(function () {
  function objetivo(root) {
    // 1) Fecha fija futura configurada → usarla. 2) Si no (o lejana >30d/pasada) → fin del día local (evergreen, siempre < 24h).
    var fija = Date.parse(root.dataset.fin);
    var ahora = Date.now();
    if (!isNaN(fija) && fija > ahora && (fija - ahora) < 2592000000) return fija;
    var horas = parseInt(root.dataset.horas, 10);
    if (horas > 0) {
      // ciclo rodante de N horas anclado a la medianoche local
      var d0 = new Date(); d0.setHours(0, 0, 0, 0);
      var trans = (ahora - d0.getTime()) / 3600000;
      return d0.getTime() + (Math.floor(trans / horas) + 1) * horas * 3600000;
    }
    var fin = new Date(); fin.setHours(24, 0, 0, 0); // próxima medianoche
    return fin.getTime();
  }
  function init(root) {
    var timer = root.querySelector('.orl-anuncio__timer');
    if (!timer) return;
    var meta = objetivo(root);
    var ids = { h: timer.querySelector('[data-t="h"]'), m: timer.querySelector('[data-t="m"]'), s: timer.querySelector('[data-t="s"]') };
    function tick() {
      var d = meta - Date.now();
      if (d <= 0) { meta = objetivo(root); d = meta - Date.now(); }
      var h = Math.floor(d / 3600000), m = Math.floor(d % 3600000 / 60000), s = Math.floor(d % 60000 / 1000);
      ids.h.textContent = String(h).padStart(2, '0');
      ids.m.textContent = String(m).padStart(2, '0');
      ids.s.textContent = String(s).padStart(2, '0');
    }
    tick();
    timer.removeAttribute('hidden');
    var iv = setInterval(tick, 1000);
    root.closest('.shopify-section') && document.addEventListener('shopify:section:unload', function (e) {
      if (e.target.contains(root)) clearInterval(iv);
    });
  }
  document.querySelectorAll('.orl-anuncio').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-anuncio'); if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var slides = root.querySelector('.orl-hero__slides');
    var thumbs = root.querySelectorAll('.orl-hero__thumb');
    if (slides && thumbs.length) {
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () {
          var idx = +t.dataset.idx;
          var slide = slides.querySelector('[data-idx="' + idx + '"]');
          if (slide) slides.scrollTo({ left: slide.offsetLeft - slides.offsetLeft, behavior: 'smooth' });
        });
      });
      slides.addEventListener('scroll', function () {
        var idx = Math.round(slides.scrollLeft / slides.clientWidth);
        thumbs.forEach(function (t) { t.classList.toggle('is-activo', +t.dataset.idx === idx); });
      }, { passive: true });
    }
    var fecha = root.querySelector('.orl-hero__entrega-fecha');
    if (fecha) {
      var d = new Date(Date.now() + (+fecha.dataset.dias || 7) * 86400000);
      var meses = ['enero','febrero','marzo','abril','mayo','junio','julio','agosto','septiembre','octubre','noviembre','diciembre'];
      var n = d.getDate();
      fecha.textContent = n + ' de ' + meses[d.getMonth()];
    }
  }
  document.querySelectorAll('.orl-hero').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-hero'); if (r) init(r);
  });
})();

// ---- Barra sticky de compra: aparece al pasar el buy box ----
(function () {
  var sticky = document.querySelector('[data-sticky]');
  if (!sticky) return;
  var form = document.querySelector('.orl-hero__form');
  var cta = document.querySelector('.orl-hero__cta');
  if (!form || !cta) return;
  sticky.removeAttribute('hidden');

  // el botón del sticky dispara el mismo comprar del hero
  var btn = sticky.querySelector('[data-sticky-btn]');
  if (btn) btn.addEventListener('click', function () {
    var r = cta.getBoundingClientRect();
    var visible = r.top < window.innerHeight && r.bottom > 0;
    if (visible) { cta.click(); }
    else { window.scrollTo({ top: window.scrollY + r.top - 180, behavior: 'smooth' }); }
  });

  var tick = false;
  function evaluar() {
    var r = cta.getBoundingClientRect();
    // visible cuando el botón principal ya quedó arriba del viewport
    var mostrar = r.bottom < 0;
    sticky.classList.toggle('is-visible', mostrar);
  }
  function pedir() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; evaluar(); }); }
  window.addEventListener('scroll', pedir, { passive: true });
  window.addEventListener('resize', pedir);
  evaluar();
})();

// ---- Barra de envío gratis (según cantidad elegida en la app de bundles) ----
(function () {
  var barra = document.querySelector('.orl-envio');
  if (!barra) return;
  var umbral = parseInt(barra.getAttribute('data-umbral'), 10) || 2;
  var elFalta = barra.querySelector('.orl-envio__falta');
  var elLogrado = barra.querySelector('.orl-envio__logrado');

  function cantidad() {
    // 1) la barra seleccionada de la app ("Lleva 2", "x2", "2 unidades"…)
    var sel = document.querySelector('.kaching-bundles__bar--selected, [class*="bundles__bar"][class*="selected"], [class*="offer-card--active"], [class*="offer-card"][class*="selected"]');
    if (sel) {
      var t = (sel.innerText || '').replace(/\s+/g, ' ');
      var m = t.match(/(?:lleva|compra|buy|x)\s*(\d+)/i) || t.match(/(\d+)\s*(?:unidades|units|botellas|u\b)/i);
      if (m) { var n = parseInt(m[1], 10); if (n > 0) return n; }
    }
    // 2) el quantity del form (la app lo mantiene sincronizado)
    var q = document.querySelector('.orl-hero__form [name="quantity"]');
    if (q) { var n2 = parseInt(q.value, 10); if (n2 > 0) return n2; }
    return 1;
  }

  function pintar() {
    var n = cantidad();
    var ok = n >= umbral;
    if (ok) { elFalta.setAttribute('hidden',''); elLogrado.removeAttribute('hidden'); }
    else { elLogrado.setAttribute('hidden',''); elFalta.removeAttribute('hidden'); }
  }

  // Dejar la barra SIEMPRE justo arriba del botón comprar (la app de bundles se
  // inyecta después en el DOM, así que hay que reubicarla cuando termina de montar).
  function reubicar() {
    var form = document.querySelector('.orl-hero__form');
    if (!form || !form.parentNode) return;
    if (barra.nextElementSibling === form) return; // ya está en su lugar
    form.parentNode.insertBefore(barra, form);
  }

  reubicar(); pintar();
  // reaccionar a cambios de la app (clases, atributos, contenido) y a clicks
  var deb = null, replantear = function () { clearTimeout(deb); deb = setTimeout(function () { reubicar(); pintar(); }, 120); };
  try {
    new MutationObserver(replantear).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'value'] });
  } catch (e) {}
  document.addEventListener('click', replantear, true);
  document.addEventListener('change', replantear, true);
  [400, 1200, 2500, 5000].forEach(function (ms) { setTimeout(function () { reubicar(); pintar(); }, ms); });
})();

// ---- Checkout directo + limpiar carrito al volver atrás ----
(function () {
  var hero = document.querySelector('.orl-hero[data-checkout-directo], .orl-hero[data-limpiar-carrito]');
  if (!hero) return;
  var directo = hero.getAttribute('data-checkout-directo') === '1';
  var limpiar = hero.getAttribute('data-limpiar-carrito') === '1';

  // Vaciar el carrito al mostrar la página (primera carga y al volver desde el checkout con "atrás")
  if (limpiar && !window.__orlClearHook) {
    window.__orlClearHook = true;
    window.addEventListener('pageshow', function () {
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } }).catch(function () {});
    });
  }

  if (!directo) return;

  var yendo = false, t = null;
  function irCheckout() { if (yendo) return; yendo = true; window.location.href = '/checkout'; }
  // debounce: agrupa varias llamadas /cart/add (packs de la app) y redirige recién cuando terminan
  function programar() { clearTimeout(t); t = setTimeout(irCheckout, 350); }
  var esAdd = function (u) { return /\/cart\/add(\.js)?(\?|$)/.test(u || ''); };

  // Intercepta el add hecho por fetch (Kaching, drawer del tema, etc.) → al checkout
  if (window.fetch && !window.__orlFetchHook) {
    window.__orlFetchHook = true;
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (esAdd(url)) { p.then(function (r) { if (r && r.ok) programar(); }).catch(function () {}); }
      return p;
    };
  }
  // Intercepta el add hecho por XHR
  if (window.XMLHttpRequest && !window.__orlXhrHook) {
    window.__orlXhrHook = true;
    var oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__orlUrl = u || ''; return oOpen.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      if (esAdd(x.__orlUrl)) { x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) programar(); }); }
      return oSend.apply(this, arguments);
    };
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-problema"] && !Shopify.designMode) return;
  try {
    
(function () {
  function armar(v) {
    v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
    v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
    v.removeAttribute('controls');
    // Carga diferida: el archivo se descarga recién cuando el video está por aparecer
    var cargado = false, enPantalla = false;
    function cargar() {
      if (cargado) return; cargado = true;
      var src = v.getAttribute('data-src');
      if (src && !v.querySelector('source')) {
        var s = document.createElement('source');
        s.src = src; s.type = 'video/mp4';
        v.appendChild(s); v.load();
      }
    }
    var play = function () { cargar(); try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} };
    v.addEventListener('loadeddata', function () { if (enPantalla) play(); });
    v.addEventListener('canplay', function () { if (enPantalla) play(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) cargar(); }); }, { rootMargin: '300px 0px' }).observe(v);
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { enPantalla = e.isIntersecting; if (e.isIntersecting) play(); else v.pause(); });
      }, { threshold: 0.2 }).observe(v);
    } else { cargar(); play(); }
  }
  function init(root) { root.querySelectorAll('.orl-prob__video, .orl-prob video').forEach(armar); }
  document.querySelectorAll('.orl-prob').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-prob'); if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-razones"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('.orl-razones__track');
    root.querySelectorAll('.orl-razones__flecha').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = track.querySelector('.orl-razones__card');
        if (card) track.scrollBy({ left: (+b.dataset.dir) * (card.offsetWidth + 14), behavior: 'smooth' });
      });
    });
  }
  document.querySelectorAll('.orl-razones').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-razones'); if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-reviews-espejo"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('.orl-espejo__track');
    var tabs = root.querySelectorAll('.orl-espejo__tab');
    var dotsWrap = root.querySelector('.orl-espejo__dots');
    function visibles() { return [].slice.call(track.querySelectorAll('.orl-espejo__card:not([hidden])')); }
    function ancho() { var c = track.querySelector('.orl-espejo__card:not([hidden])'); return c ? c.offsetWidth + 14 : 300; }
    function pintarDots() {
      if (!dotsWrap) return;
      var n = visibles().length;
      dotsWrap.innerHTML = '';
      for (var i = 0; i < n; i++) {
        var b = document.createElement('button');
        b.dataset.idx = i;
        if (i === 0) b.className = 'is-activo';
        b.addEventListener('click', function () { track.scrollTo({ left: (+this.dataset.idx) * ancho(), behavior: 'smooth' }); });
        dotsWrap.appendChild(b);
      }
    }
    function syncDots() {
      if (!dotsWrap) return;
      var idx = Math.round(track.scrollLeft / ancho());
      dotsWrap.querySelectorAll('button').forEach(function (d, i) { d.classList.toggle('is-activo', i === idx); });
    }
    function filtrar(g) {
      track.querySelectorAll('.orl-espejo__card').forEach(function (c) {
        if (c.dataset.grupo === g) c.removeAttribute('hidden'); else c.setAttribute('hidden', '');
      });
      track.scrollTo({ left: 0 });
      pintarDots();
    }
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        tabs.forEach(function (x) { x.classList.remove('is-activo'); x.setAttribute('aria-selected', 'false'); });
        t.classList.add('is-activo'); t.setAttribute('aria-selected', 'true');
        filtrar(t.dataset.grupo);
      });
    });
    filtrar('a');
    track.addEventListener('scroll', syncDots, { passive: true });
    root.querySelectorAll('.orl-espejo__flecha').forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: (+b.dataset.dir) * ancho(), behavior: 'smooth' });
      });
    });
  }
  document.querySelectorAll('.orl-espejo').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-espejo'); if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-ritual"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('.orl-ritual__track');
    var dots = root.querySelectorAll('.orl-ritual__dot');
    function anchoPaso() {
      var p = track.querySelector('.orl-ritual__paso');
      return p ? p.offsetWidth + 14 : 300;
    }
    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        track.scrollTo({ left: (+d.dataset.idx) * anchoPaso(), behavior: 'smooth' });
      });
    });
    root.querySelectorAll('.orl-ritual__flecha').forEach(function (b) {
      b.addEventListener('click', function () {
        track.scrollBy({ left: (+b.dataset.dir) * anchoPaso(), behavior: 'smooth' });
      });
    });
    track.addEventListener('scroll', function () {
      var idx = Math.round(track.scrollLeft / anchoPaso());
      dots.forEach(function (d, i) { d.classList.toggle('is-activo', i === idx); });
    }, { passive: true });
  }
  document.querySelectorAll('.orl-ritual').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-ritual'); if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-stats"] && !Shopify.designMode) return;
  try {
    
(function () {
  function animar(el) {
    var fin = parseInt(el.dataset.pct, 10) || 0;
    var t0 = null;
    function frame(t) {
      if (!t0) t0 = t;
      var p = Math.min((t - t0) / 900, 1);
      el.textContent = Math.round(fin * (1 - Math.pow(1 - p, 3))) + '%';
      if (p < 1) requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }
  function init(root) {
    var nums = root.querySelectorAll('.orl-stats__num');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      nums.forEach(function (n) { n.textContent = (parseInt(n.dataset.pct, 10) || 0) + '%'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { animar(e.target); io.unobserve(e.target); }
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io.observe(n); });
  }
  // ---- Carrusel de testimonios ----
  function carrusel(root) {
    var track = root.querySelector('[data-track]');
    if (!track) return;
    var slides = [].slice.call(track.querySelectorAll('.orl-stats__slide'));
    var dots = [].slice.call(root.querySelectorAll('.orl-stats__dot'));
    if (!slides.length) return;

    function irA(i) {
      var s = slides[Math.max(0, Math.min(i, slides.length - 1))];
      if (s) track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }
    function actual() {
      var min = Infinity, idx = 0;
      slides.forEach(function (s, i) {
        var d = Math.abs(s.getBoundingClientRect().left - track.getBoundingClientRect().left);
        if (d < min) { min = d; idx = i; }
      });
      return idx;
    }
    root.querySelectorAll('.orl-stats__flecha-nav').forEach(function (b) {
      b.addEventListener('click', function () { irA(actual() + (+b.dataset.dir)); });
    });
    dots.forEach(function (d) {
      d.addEventListener('click', function () { irA(+d.dataset.idx); });
    });
    // centrar las flechas sobre la foto del testimonio visible
    var carr = root.querySelector('.orl-stats__carrusel');
    function ubicarFlechas() {
      if (!carr) return;
      var s = slides[actual()];
      var img = s && s.querySelector('.orl-stats__foto');
      if (!img || !img.offsetHeight) return;
      var centro = (img.getBoundingClientRect().top - carr.getBoundingClientRect().top) + img.offsetHeight / 2;
      carr.style.setProperty('--orl-flecha-top', Math.round(centro) + 'px');
    }
    ubicarFlechas();
    window.addEventListener('resize', ubicarFlechas);
    root.querySelectorAll('.orl-stats__foto').forEach(function (im) {
      if (im.complete) ubicarFlechas(); else im.addEventListener('load', ubicarFlechas);
    });
    [300, 1000, 2200].forEach(function (ms) { setTimeout(ubicarFlechas, ms); });

    var tick = false;
    track.addEventListener('scroll', function () {
      if (tick) return; tick = true;
      requestAnimationFrame(function () {
        tick = false;
        var i = actual();
        dots.forEach(function (d, j) { d.classList.toggle('is-activo', j === i); });
        ubicarFlechas();
      });
    }, { passive: true });
  }
  document.querySelectorAll('.orl-stats').forEach(function (r) { init(r); carrusel(r); });
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-stats'); if (r) { init(r); carrusel(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-tabs"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var tabs = root.querySelectorAll('.orl-tabs__tab');
    var panels = root.querySelectorAll('.orl-tabs__panel');
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var key = tab.dataset.panel;
        tabs.forEach(function (t) {
          var on = t === tab;
          t.classList.toggle('is-activo', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        panels.forEach(function (p) {
          var on = p.dataset.panel === key;
          p.classList.toggle('is-activo', on);
          if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        });
        var nav = root.querySelector('.orl-tabs__nav');
        var y = root.getBoundingClientRect().top + window.scrollY - 8;
        if (window.scrollY > y) window.scrollTo({ top: y, behavior: 'smooth' });
      });
    });
  }
  document.querySelectorAll('.orl-tabs').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-tabs'); if (r) init(r);
  });

  // ---- Timeline: la línea se llena con el scroll y cada hito se enciende al pasar ----
  function animarTimeline(tl) {
    if (!tl) return;
    var fill = tl.querySelector('[data-linea-fill]');
    var hitos = [].slice.call(tl.querySelectorAll('[data-hito]'));
    if (!fill || !hitos.length) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function actualizar() {
      if (!tl.offsetParent) return; // panel oculto
      var r = tl.getBoundingClientRect();
      var alto = tl.offsetHeight;
      // punto de referencia: 55% del viewport
      var marca = window.innerHeight * 0.55;
      var avance = marca - r.top;
      var pct = Math.max(0, Math.min(1, avance / Math.max(alto, 1)));
      fill.style.setProperty('height', (pct * alto) + 'px', 'important');
      hitos.forEach(function (h) {
        var hr = h.getBoundingClientRect();
        var on = (hr.top + 18) < marca;
        h.classList.toggle('is-activo', on);
      });
    }

    if (reduce) { // sin animación: todo encendido
      fill.style.setProperty('height', '100%', 'important');
      hitos.forEach(function (h) { h.classList.add('is-activo'); });
      return;
    }
    var tick = false;
    function pedir() { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; actualizar(); }); }
    window.addEventListener('scroll', pedir, { passive: true });
    window.addEventListener('resize', pedir);
    document.addEventListener('click', function () { setTimeout(actualizar, 60); }, true);
    actualizar();
    [200, 700, 1500].forEach(function (ms) { setTimeout(actualizar, ms); });
  }
  document.querySelectorAll('.orl-tabs__timeline').forEach(animarTimeline);
  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('.orl-tabs__timeline').forEach(animarTimeline);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-testimonios"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('.orl-testimonios__track');
    root.querySelectorAll('.orl-testimonios__flecha').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = track.querySelector('.orl-testimonios__card');
        if (card) track.scrollBy({ left: (+b.dataset.dir) * (card.offsetWidth + 14), behavior: 'smooth' });
      });
    });
  }
  document.querySelectorAll('.orl-testimonios').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-testimonios'); if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-transformaciones"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    var track = root.querySelector('.orl-transf__track');
    root.querySelectorAll('.orl-transf__flecha').forEach(function (b) {
      b.addEventListener('click', function () {
        var card = track.querySelector('.orl-transf__card');
        if (card) track.scrollBy({ left: (+b.dataset.dir) * (card.offsetWidth + 14), behavior: 'smooth' });
      });
    });
  }
  document.querySelectorAll('.orl-transf').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-transf'); if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orl-ugc-videos"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    // botón de play viejo (solo queda si hay una imagen sin video)
    root.querySelectorAll('.orl-ugc__play').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var video = btn.parentElement.querySelector('video');
        if (!video) return;
        if (video.paused) { video.play(); btn.style.setProperty('opacity', '0', 'important'); }
        else { video.pause(); btn.style.setProperty('opacity', '1', 'important'); }
      });
    });

    root.querySelectorAll('.orl-ugc__slide').forEach(function (slide) {
      var v = slide.querySelector('video');
      if (!v) return;
      v.muted = true; v.defaultMuted = true; v.loop = true; v.playsInline = true;
      v.setAttribute('muted', ''); v.setAttribute('playsinline', ''); v.setAttribute('webkit-playsinline', '');
      v.removeAttribute('controls');

      // Carga diferida: el archivo recién se descarga cuando el video está por entrar en pantalla
      var cargado = false;
      function cargar() {
        if (cargado) return; cargado = true;
        var src = v.getAttribute('data-src');
        if (src && !v.querySelector('source')) {
          var s = document.createElement('source');
          s.src = src; s.type = 'video/mp4';
          v.appendChild(s);
          v.load();
        }
      }
      function play() { cargar(); try { var p = v.play(); if (p && p.catch) p.catch(function () {}); } catch (e) {} }
      function marcar() { slide.classList.toggle('is-reproduciendo', !v.paused && v.currentTime > 0); }
      v.addEventListener('playing', marcar); v.addEventListener('timeupdate', marcar); v.addEventListener('pause', marcar);
      v.addEventListener('loadeddata', function () { if (enPantalla) play(); });
      v.addEventListener('canplay', function () { if (enPantalla) play(); });
      var enPantalla = false;
      if ('IntersectionObserver' in window) {
        // precargar un poco antes de que aparezca, para que no se vea el salto
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { if (e.isIntersecting) cargar(); });
        }, { rootMargin: '300px 0px' }).observe(slide);
        // reproducir/pausar según esté a la vista (ahorra datos y batería)
        new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            enPantalla = e.isIntersecting;
            if (e.isIntersecting) play(); else if (v.muted) v.pause();
          });
        }, { threshold: 0.35 }).observe(slide);
      } else { cargar(); play(); }

      // botón de sonido (abajo a la derecha)
      var btn = slide.querySelector('[data-sonido]');
      if (btn) {
        var icoMute = btn.querySelector('.orl-ugc__ico-mute');
        var icoSon = btn.querySelector('.orl-ugc__ico-son');
        function pintar() {
          var conSonido = !v.muted;
          if (icoMute) conSonido ? icoMute.setAttribute('hidden', '') : icoMute.removeAttribute('hidden');
          if (icoSon) conSonido ? icoSon.removeAttribute('hidden') : icoSon.setAttribute('hidden', '');
          btn.setAttribute('aria-pressed', conSonido ? 'true' : 'false');
          btn.setAttribute('aria-label', conSonido ? 'Silenciar video' : 'Activar sonido');
        }
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          if (v.muted) {
            // al activar el sonido de uno, silenciar los demás
            document.querySelectorAll('.orl-ugc video').forEach(function (o) {
              if (o !== v) { o.muted = true; var ob = o.closest('.orl-ugc__slide'); if (ob) { var b2 = ob.querySelector('[data-sonido]'); if (b2) { var m = b2.querySelector('.orl-ugc__ico-mute'), s = b2.querySelector('.orl-ugc__ico-son'); if (m) m.removeAttribute('hidden'); if (s) s.setAttribute('hidden', ''); b2.setAttribute('aria-pressed', 'false'); } } }
            });
            v.muted = false; v.volume = 1; play();
          } else { v.muted = true; }
          pintar();
        });
        v.addEventListener('volumechange', pintar);
        pintar();
      }

      // tocar el video: pausa / reanuda
      slide.addEventListener('click', function (e) {
        if (e.target.closest('[data-sonido]')) return;
        if (v.paused) play(); else v.pause();
      });
    });
  }
  document.querySelectorAll('.orl-ugc').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('.orl-ugc'); if (r) init(r);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
